"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ThreeLineViewPreviewLine_1 = require("./ThreeLineViewPreviewLine");
var ThreeLineViewSenderLine_1 = require("./ThreeLineViewSenderLine");
var ThreeLineViewSubjectLine_1 = require("./ThreeLineViewSubjectLine");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var ThreeLineViewSecondColumn = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeLineViewSecondColumn, _super);
    function ThreeLineViewSecondColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeLineViewSecondColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.column },
            React.createElement(ThreeLineViewSenderLine_1.default, { isSelected: this.props.isSelected, isUnread: this.props.isUnread, senderTexts: this.props.senderTexts, iconBarUrl: this.props.iconBarUrl, adId: this.props.adId }),
            React.createElement(ThreeLineViewSubjectLine_1.default, { isUnread: this.props.isUnread, subjectTexts: this.props.subjectTexts, originalPriceTexts: this.props.originalPriceTexts, currentPriceTexts: this.props.currentPriceTexts }),
            React.createElement(ThreeLineViewPreviewLine_1.default, { previewTexts: this.props.previewTexts })));
    };
    ThreeLineViewSecondColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThreeLineViewSecondColumn);
    return ThreeLineViewSecondColumn;
}(React.Component));
exports.default = ThreeLineViewSecondColumn;
//# sourceMappingURL=ThreeLineViewSecondColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/ThreeLineViewSecondColumn.js
// module id = 6004
// module chunks = 67